import React, {useState} from 'react';
import {Button, Menu, Modal, Typography} from "antd";
const { Paragraph } = Typography;

import type { MenuProps } from 'antd';
import {MailOutlined, FormOutlined} from "@ant-design/icons";
import {EventService} from "../services/eventService";

type Props = {
    userId: string,
    taskId: string
}

export default function Header(props: Props) {
    const [modal, setModal] = useState(false);

    const items: MenuProps["items"] = [
        {
            label: "Help",
            key: "help",
            icon: <MailOutlined/>
        },
        {
            label: (
                <a href="https://ubc.ca1.qualtrics.com/jfe/form/SV_5aJbVNvCqZLIINU" rel="noopener noreferrer">
                    Return to Survey
                </a>
            ),
            key: 'survey',
            icon: <FormOutlined/>
        }
    ];

    const handleOnClick = (item: any) => {
        if (item.key === "help") {
            setModal(true);

            const eventService = new EventService()
            const date = new Date();
            eventService.saveEvent(props.userId, props.taskId, {
                id: date.getTime(),
                type: "HELP_OPENED",
                time: date.toString(),
                value: {}
            });
        }
    }

    const handleCancel = () => {
        setModal(false);
    }

    return <>
        <h2 className="logo">StitchUp</h2>
        <Menu
            selectedKeys={[]}
            theme="dark"
            mode="horizontal"
            items={items}
            onClick={(item) => handleOnClick(item)}
            style={{justifyContent: 'flex-end'}}/>
        <Modal
            title="Looking for Help?"
            open={modal}
            onCancel={handleCancel}
            footer={[
                <Button type="primary" key="back" onClick={handleCancel}>
                    Ok
                </Button>]}>
            <Paragraph>
                You can email Katharine at kekerr@cs.ubc.ca with any questions or issues.
            </Paragraph>
            {/*<Paragraph>*/}
            {/*    If you are really stuck, you can pause the study here and then continue it*/}
            {/*    after we have talked about the issue.*/}
            {/*</Paragraph>*/}
            <Paragraph>
                Also, if it would be helpful and if you live in the Vancouver Lower Mainland, then you can choose to do the study in person.
            </Paragraph>
        </Modal>
    </>
}